import { Platform } from 'react-native';
import platform from 'platform';
import * as Device from 'expo-device';

export const getDeviceInfo = () => {
  let deviceId: string | null | undefined;
  let deviceModel: string | null | undefined;
  let OSId: string | null | undefined;
  let OSVersion: string | null | undefined;
  if (Platform.OS === 'web') {
    deviceId = '';
    deviceModel = window.navigator.userAgent?.split(' ')[0];
    OSId = platform.os?.family;
    OSVersion = platform.os?.version;
  } else {
    deviceId = '';
    deviceModel = Device.deviceName;
    OSId = Device.osName;
    OSVersion = Device.osVersion;
  }
  return {
    deviceId: deviceId || 'Indefinido',
    deviceModel: deviceModel || 'Indefinido',
    OSId: OSId || 'Indefinido',
    OSVersion: OSVersion || 'Indefinido',
  };
};
